import { render, staticRenderFns } from "./CommunityBoards.vue?vue&type=template&id=4b46bb3f&scoped=true&"
import script from "./CommunityBoards.vue?vue&type=script&lang=js&"
export * from "./CommunityBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46bb3f",
  null
  
)

export default component.exports